import React from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  // const [PDf, setPDF] = React.useState(FetchData.meta.book_pdf)
  // const [Author, setAuthor] = React.useState(FetchData.meta.book_author)
  // const [PublishedDate, setPublishedDate] = React.useState(FetchData.meta.book_published_date)
  // const [AboutBook, setAboutBook] = React.useState(FetchData.meta.about_book)

  const [content, setContent] = React.useState(FetchData.meta.content)
  const [FeaturedImage, setFeaturedImage] = React.useState(FetchData.meta.featured_image)
  const [Links, setLinks] = React.useState(FetchData.meta.links)
  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "content": content,
        "featured_image": FeaturedImage,
        "links": Links
      }
    }

    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_information)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Information Added Successfully")
          history.push(`${slugs.information_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_information, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }
  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Video Information</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Title</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Title} placeholder="Title"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Featured Image</td>
                <td className="col-6">
                  {/* <a href={PDf} target="_blank">{}</a> */}
                  <ImageUpload
                    ImageUrl={FeaturedImage}
                    setImageUrl={setFeaturedImage}
                  />
                </td>
              </tr>
              {/* {YouTubeGetID(VideoYoutubeUrl)} */}
              <tr>
                <td className="col-3">Content</td>
                <td className="col-6">
                  <textarea className="input-common" rows={5}
                    value={content} placeholder="Content"
                    onChange={(event) => {
                      setContent(event.target.value)
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Redirect Link</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Links} placeholder="Redirect Link"
                    onChange={(event) => {
                      setLinks(event.target.value)
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Video
              </div>
            </div>
          </div>
        </div>
      </div>

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div>
  )

}